import {
  useCatalogOverlayStore,
  type CatalogHubSegment,
  type CatalogProductDetailTab,
} from '../store/useCatalogOverlayStore';

/** Abre la ficha del producto en Catálogo → Productos (desde Combos u otros módulos). */
export function requestCatalogProductDetail(
  productId: string,
  opts?: {
    tab?: CatalogProductDetailTab;
    hubSegment?: CatalogHubSegment;
    recipeKind?: 'assemble' | 'disassemble';
  },
) {
  const store = useCatalogOverlayStore.getState();
  store.requestCatalogHubSegment(opts?.hubSegment ?? 'products');
  store.requestOpenProductDetail(
    productId,
    opts?.tab ?? 'composicion',
    opts?.recipeKind,
  );
}

/** Atajo hub Combos → lista filtrada en Productos. */
export function requestCatalogComboListView() {
  const store = useCatalogOverlayStore.getState();
  store.requestCatalogHubSegment('products');
  store.requestCatalogItemTypeFilter('combo');
}
